"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YesNoFieldLogic = void 0;
const yes_no_1 = require("../../aggregations/yes-no");
const types_1 = require("@smartsuite/types");
const field_logic_1 = require("../../field-type-registry/field-logic");
const clipboard_1 = require("../../utils/clipboard");
const comparisons_1 = require("../../comparisons/comparisons");
const migration_1 = require("../../utils/migration");
const intl_1 = require("../../locale/intl");
const yes_no_fieldtype_1 = require("../../safe-field-value/yes-no-field/yes-no.fieldtype");
const texts_1 = require("../../texts");
class YesNoFieldLogic extends field_logic_1.BaseFieldTypeLogic {
    constructor() {
        super(...arguments);
        this.name = "yesnofield";
        this.label = (0, intl_1.$t)(texts_1.yesNoFieldText.yes_no);
        this.icon = "yes-and-no";
        this.iconColor = "#883CD0";
        this.placeholder = (0, intl_1.$t)(texts_1.yesNoFieldText.select_yes_or_no);
        this.searchSynonyms = [
            (0, intl_1.$t)(texts_1.yesNoFieldText.true).toLocaleLowerCase(),
            (0, intl_1.$t)(texts_1.yesNoFieldText.false).toLocaleLowerCase(),
            "si no",
        ];
        this.lookupMode = "lookup";
        // @ts-expect-error: Need to resolve
        this.comparisons = {
            is: comparisons_1.yesNoIsEqualTo,
        };
        this.aggregates = {
            empty: {
                label: (0, intl_1.$t)(texts_1.aggregatesText.empty),
                aggregator: yes_no_1.yesNoCountEmpty,
            },
            "non-empty": {
                label: (0, intl_1.$t)(texts_1.aggregatesText.non_empty),
                aggregator: yes_no_1.yesNoCountFilled,
            },
            "percent-filled": {
                label: (0, intl_1.$t)(texts_1.aggregatesText.percent_filled),
                aggregator: yes_no_1.yesNoPercentFilled,
            },
            "percent-empty": {
                label: (0, intl_1.$t)(texts_1.aggregatesText.percent_empty),
                aggregator: yes_no_1.yesNoPercentEmpty,
            },
        };
        this.groupByMode = "groupBy";
        this.fieldValueGetter = new yes_no_fieldtype_1.YesNoFieldValueGetter();
        // @ts-expect-error: Need to resolve
        this.clipboardPasteRules = {
            yesnofield: clipboard_1.clipboardYesNoSelf,
            textfield: clipboard_1.clipboardTextToYesNo,
            recordtitlefield: clipboard_1.clipboardTextToYesNo,
            tagsfield: clipboard_1.clipboardTextToYesNo,
            unknownfield: clipboard_1.clipboardTextToYesNo,
        };
    }
    sortKey(fieldValue) {
        // Sort by !value, so the default ascending sort will be True first
        return fieldValue ? 0 : 1;
    }
    valueToString(value) {
        return value ? (0, intl_1.$t)(texts_1.yesNoFieldText.yes) : (0, intl_1.$t)(texts_1.yesNoFieldText.no);
    }
    prepareValueForClipboard(value) {
        return {
            text: value ? (0, intl_1.$t)(texts_1.yesNoFieldText.yes) : (0, intl_1.$t)(texts_1.yesNoFieldText.no),
            rawValue: value,
        };
    }
    searchKey(value) {
        if (value) {
            return [
                (0, intl_1.$t)(texts_1.yesNoFieldText.yes),
                (0, intl_1.$t)(texts_1.yesNoFieldText.on),
                (0, intl_1.$t)(texts_1.yesNoFieldText.selected),
                (0, intl_1.$t)(texts_1.yesNoFieldText.true),
            ].join(" ");
        }
        return [
            (0, intl_1.$t)(texts_1.yesNoFieldText.no),
            (0, intl_1.$t)(texts_1.yesNoFieldText.off),
            (0, intl_1.$t)(texts_1.yesNoFieldText.not),
            (0, intl_1.$t)(texts_1.yesNoFieldText.false),
        ].join(" ");
    }
    getInlineEditRules(field) {
        return {
            ...super.getInlineEditRules(field),
            saveKeys: types_1.navigationKeys,
            switchToInputControl: "OnCellSelect",
            editorWidth: "100%",
            editOnStartTyping: false,
            enableCopyEventInEditMode: true,
            enablePasteEventInEditMode: true,
            spaceKeyOpensRecordModal: () => true,
        };
    }
    getEmptyValue() {
        return false;
    }
    getInitialFieldValue(startValue) {
        return !!startValue || this.getEmptyValue();
    }
    isValueEmpty(fieldValue) {
        return fieldValue === null || fieldValue === undefined;
    }
    showActivityUpdate(_fieldValue) {
        return true;
    }
    isImportedValueValid(parsedValue) {
        return parsedValue !== null;
    }
    getLinkedRecordFieldSmartWidth(_field) {
        return {
            defaultWidht: 90,
            minWidth: 45,
        };
    }
    migrateField(fieldTo, fieldFrom) {
        var _a;
        const migratedField = super.migrateField(fieldTo, fieldFrom);
        return (0, migration_1.migrateDisplayFormat)(migratedField, types_1.yesNoDisplayFormats, (_a = fieldTo.params.display_format) !== null && _a !== void 0 ? _a : "");
    }
    filterToRecordValue(filterValue, comparison, field) {
        if (comparison === "is") {
            return filterValue;
        }
        throw new types_1.FilterToRecordValueConversionError(field, filterValue, comparison);
    }
}
exports.YesNoFieldLogic = YesNoFieldLogic;
